import React, { useContext } from 'react';
import styled from 'styled-components/macro';
import { TABLET_WIDTH, MOBILE_WIDTH } from '../../constants/dims';
import imgCollaborate from '../../assets/img/collaborate.png';
import routes from '../../constants/routes';
import PreferencesContext from '../../contexts/preferences';

const Section = styled.section`
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  color: ${props => props.theme.collaborate.text};
  background-color: ${props => props.theme.collaborate.backgroundColor};
  padding: 32px;
  box-sizing: border-box;
`;

const Container = styled.div`
  max-width: ${TABLET_WIDTH}px;
  text-align: center;

  & > h4 {
    padding: 0 20px;
  }
`;

const ImgWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 20px;

  & > div {
    max-width: 840px;
    text-align: center;
  }
`;

export const Columns = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 24px;
  padding: 20px;
  box-sizing: border-box;
`;

export const Column = styled.div`
  flex: 1 1 192px;
  min-width: 192px;
  text-align: center;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-bottom: 24px;

  &:last-child {
    padding-left: 24px;
    margin-bottom: 0px;

    @media screen and (max-width: ${MOBILE_WIDTH}px) {
      padding-left: 0;
    }
  }

  & > p {
    max-width: 155px;
  }
`;

const Header = styled.div`
  margin-bottom: 24px;
  padding: 20px;
  box-sizing: border-box;
`;

export const Check = () => (
  <i
    className="fas fa-check-circle fa-2x"
    style={{ color: '#64c7c9', marginBottom: 20 }}
  ></i>
);

const Collaborate = () => {
  const { inGame } = useContext(PreferencesContext);
  return (
    <Section id="collaborate">
      <Container>
        <Header>
          <h2>
            Our Mathematics Matters&trade; project invites scientific scrutiny
          </h2>
          <h5>
            We provide researchers with free access to put our work to the test,
            since we refuse to waste families' and schools' resources on
            unproven products.
          </h5>
        </Header>

        <ImgWrapper>
          <div>
            <img src={imgCollaborate} alt="" />
          </div>
        </ImgWrapper>

        <Columns>
          <Column>
            <Check />
            <p>Free access to BrainQuake training</p>
          </Column>

          <Column>
            <Check />
            <p>Online cognitive assessments</p>
          </Column>

          <Column>
            <Check />
            <p>Guidance on data analysis</p>
          </Column>

          <Column>
            <Check />
            <p>Online surveys for participants</p>
          </Column>
        </Columns>

        <h4>
          Would you like to conduct research on BrainQuake’s products?{' '}
          {!inGame ? (
            <a href={routes.research}>Learn More</a>
          ) : (
            <span>
              Visit <a href="http://www.brainquake.com">www.brainquake.com</a>{' '}
              to learn more.
            </span>
          )}
        </h4>
      </Container>
    </Section>
  );
};

export default Collaborate;
